import pairingsActionTypes from "./pairings.types";

const INITIAL_STATE = {
  pairs: [],
  challenge: null,
  myPair: null,
  currentRound: 1,
  totalRounds: 1,
  isFinalRound: false,
  selectedRound: 1,
  selections: {
    losers: [],
    winners: [],
  },
  mySubmission: null,
  roundStatus: {
    allPairsComplete: false,
    totalPairs: 0,
    completedPairs: 0,
    canAdvance: false,
  },
  loading: false,
  submitting: false,
  error: null,
  // listing page state
  allPairings: [],
  userPairings: [],
  creatorPairings: [],
  isAllPairingsLoading: false,
  isUserPairingsLoading: false,
  isCreatorPairingsLoading: false,
  pairingsError: null,
  userPairingsError: null,
  creatorPairingsError: null,
  pairsWinners: [],
  isPairsWinnersLoading: false,
};

const pairingsReducer = (state = INITIAL_STATE, action) => {
  if (action.type?.includes("VERIFY_WINNERS")) {
    console.log("[REDUCER] Action:", action.type, action.payload);
  }
  switch (action.type) {
    case pairingsActionTypes.FETCH_CHALLENGE_PAIRINGS_START:
    case pairingsActionTypes.FETCH_MY_PAIR_STATUS_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case pairingsActionTypes.FETCH_CHALLENGE_PAIRINGS_SUCCESS: {
      const firstPair = action.payload.pairs?.[0];
      const currentRoundFromPair = firstPair?.currentRound || 1;
      const totalRounds = action.payload.challenge?.rounds || 1;
      return {
        ...state,
        loading: false,
        pairs: action.payload.pairs,
        challenge: action.payload.challenge,
        currentRound: currentRoundFromPair,
        totalRounds: totalRounds,
        isFinalRound: currentRoundFromPair === totalRounds,
        selectedRound: currentRoundFromPair,
      };
    }

    case pairingsActionTypes.FETCH_MY_PAIR_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        myPair: action.payload,
        mySubmission: action.payload.mySubmission || null,
      };

    case pairingsActionTypes.FETCH_CHALLENGE_PAIRINGS_FAILURE:
    case pairingsActionTypes.FETCH_MY_PAIR_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case pairingsActionTypes.SUBMIT_LOSERS_START:
    case pairingsActionTypes.UPDATE_LOSERS_START:
    case pairingsActionTypes.SUBMIT_WINNERS_START:
    case pairingsActionTypes.UPDATE_WINNERS_START:
      return {
        ...state,
        submitting: true,
        error: null,
      };

    case pairingsActionTypes.SUBMIT_LOSERS_SUCCESS:
    case pairingsActionTypes.UPDATE_LOSERS_SUCCESS:
    case pairingsActionTypes.SUBMIT_WINNERS_SUCCESS:
    case pairingsActionTypes.UPDATE_WINNERS_SUCCESS:
      return {
        ...state,
        submitting: false,
        mySubmission: action.payload,
        selections: { losers: [], winners: [] },
      };

    case pairingsActionTypes.SUBMIT_LOSERS_FAILURE:
    case pairingsActionTypes.UPDATE_LOSERS_FAILURE:
    case pairingsActionTypes.SUBMIT_WINNERS_FAILURE:
    case pairingsActionTypes.UPDATE_WINNERS_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload,
      };

    case pairingsActionTypes.CHECK_ROUND_COMPLETION_SUCCESS:
      return {
        ...state,
        roundStatus: action.payload,
      };

    case pairingsActionTypes.SET_SELECTED_ROUND:
      return {
        ...state,
        selectedRound: action.payload,
      };

    case pairingsActionTypes.SET_SELECTIONS:
      return {
        ...state,
        selections: {
          ...state.selections,
          ...action.payload,
        },
      };

    case pairingsActionTypes.CLEAR_SELECTIONS:
      return {
        ...state,
        selections: { losers: [], winners: [] },
      };

    case pairingsActionTypes.CLEAR_PAIRINGS:
      return INITIAL_STATE;

    case pairingsActionTypes.FETCH_ALL_PAIRINGS_START:
      return {
        ...state,
        isAllPairingsLoading: true,
        pairingsError: null,
      };
    case pairingsActionTypes.FETCH_ALL_PAIRINGS_SUCCESS:
      return {
        ...state,
        isAllPairingsLoading: false,
        allPairings: action.payload,
        pairingsError: null,
      };
    case pairingsActionTypes.FETCH_ALL_PAIRINGS_FAILURE:
      return {
        ...state,
        isAllPairingsLoading: false,
        pairingsError: action.payload,
      };

    case pairingsActionTypes.FETCH_USER_PAIRINGS_START:
      return {
        ...state,
        isUserPairingsLoading: true,
        userPairingsError: null,
      };
    case pairingsActionTypes.FETCH_USER_PAIRINGS_SUCCESS:
      return {
        ...state,
        isUserPairingsLoading: false,
        userPairings: action.payload,
        userPairingsError: null,
      };
    case pairingsActionTypes.FETCH_USER_PAIRINGS_FAILURE:
      return {
        ...state,
        isUserPairingsLoading: false,
        userPairingsError: action.payload,
      };

    case pairingsActionTypes.FETCH_CREATOR_PAIRINGS_START:
      return {
        ...state,
        isCreatorPairingsLoading: true,
        creatorPairingsError: null,
      };
    case pairingsActionTypes.FETCH_CREATOR_PAIRINGS_SUCCESS:
      return {
        ...state,
        isCreatorPairingsLoading: false,
        creatorPairings: action.payload,
        creatorPairingsError: null,
      };
    case pairingsActionTypes.FETCH_CREATOR_PAIRINGS_FAILURE:
      return {
        ...state,
        isCreatorPairingsLoading: false,
        creatorPairingsError: action.payload,
      };

    case pairingsActionTypes.VERIFY_LOSERS_START:
      return {
        ...state,
        submitting: true,
        error: null,
      };

    case pairingsActionTypes.VERIFY_LOSERS_SUCCESS:
      return {
        ...state,
        submitting: false,
        // Update the pair's moveToNextRound status in state
        pairs: state.pairs.map((pair) =>
          pair._id === state.myPair?._id
            ? { ...pair, moveToNextRound: "Verified" }
            : pair,
        ),
        myPair: state.myPair
          ? { ...state.myPair, moveToNextRound: "Verified" }
          : null,
      };

    case pairingsActionTypes.VERIFY_LOSERS_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload,
      };

    case pairingsActionTypes.VERIFY_WINNERS_START:
      return {
        ...state,
        submitting: true,
        error: null,
      };

    case pairingsActionTypes.VERIFY_WINNERS_SUCCESS:
      return {
        ...state,
        submitting: false,
        // Update pairs and mark challenge as ended
        pairs: state.pairs.map((pair) =>
          pair._id === state.myPair?._id
            ? { ...pair, verifiedWinners: "Verified", ended: true }
            : pair,
        ),
        myPair: state.myPair
          ? { ...state.myPair, verifiedWinners: "Verified", ended: true }
          : null,
        challenge: state.challenge ? { ...state.challenge, ended: true } : null,
      };

    case pairingsActionTypes.VERIFY_WINNERS_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload,
      };

    case pairingsActionTypes.FETCH_PAIRS_WINNERS_START:
      return {
        ...state,
        isPairsWinnersLoading: true,
        error: null,
      };

    case pairingsActionTypes.FETCH_PAIRS_WINNERS_SUCCESS:
      return {
        ...state,
        isPairsWinnersLoading: false,
        pairsWinners: action.payload,
      };

    case pairingsActionTypes.FETCH_PAIRS_WINNERS_FAILURE:
      return {
        ...state,
        isPairsWinnersLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default pairingsReducer;
